import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
    })
export class HeaderService {

    private _headerImage = '';
    private _headerTitle = '';
    private _headerContext = '';

    setHeaderImage(image: string): void {
        this._headerImage = image;
    }

    setHeaderTitle(title: string): void {
        this._headerTitle = title;
    }

    setHeaderContext(context: string): void {
        this._headerContext = context;
    }

    get headerImage(): string {
        return this._headerImage;
    }

    /** Ready-to-bind CSS value for the page banner. */
    get headerBackground(): string {
        return this._headerImage ? `url(${this._headerImage})` : 'none';
    }

    get headerTitle(): string {
        return this._headerTitle;
    }

    get headerContext(): string {
        return this._headerContext;
    }
}
